export const loadScript = ({
  scriptId, src, callback, onError,
}) => {
  const existingScript = document.getElementById(scriptId);

  if (!existingScript) {
    const script = document.createElement('script');
    script.src = src;
    script.id = scriptId;
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };

    script.onerror = () => {
      // Need the console error so that TrackJS can catch it.
      // eslint-disable-next-line no-console
      console.error(`Error trying to load third party script "${script}": ${src}`);
      if (onError) onError();
    };
  }

  if (existingScript && callback) callback();
};

export default {
  loadScript,
};
